<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Modul-Vorlage bearbeiten</h2>

        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div v-else :key="1">
                <div class="input-row" v-if="moduleFetched" style="margin-bottom: 4px">
                    <inputFloatLabel style="width: 50%; margin-right: 4px" label="Vorlagenname"
                                     @input="moduleNameChanged"
                                     :value="this.module.name"></inputFloatLabel>
                    <inputFloatLabel style="width: 50%" label="Technischer Name" @input="technicalNameChanged"
                                     :value="this.module.technical_name"></inputFloatLabel>
                </div>
                <div class="item-row">
                    <div class="add-buttons">
                        <AdaButton title="INTERACTION HINZUFÜGEN" @click="showAddInteractionsDialog = true"
                                   type="createButton"
                                   icon="icon-add"></AdaButton>
                    </div>
                </div>
                <AdaDatatable style="margin-bottom: 20px" :columns="columns" :data="interactions"
                              :show-pagination="false"
                              :show-search="false"
                              :size-of-page="100"
                              :movable="true"
                              @moveUp="moveUp"
                              @moveDown="moveDown"
                              @rowClicked="cellClicked"
                              :transformers="transformers">
                </AdaDatatable>
                <AdaButton icon="icon-add" @click="openDialog" type="fullWidthButton"
                           title="TRACKING HINZUFÜGEN"></AdaButton>
                <div style="margin-top: 20px">
                    <AdaButton :loading="savingTemplate" style="width: 300px; height: 40px" title="MODUL SPEICHERN"
                               @click="editClicked" type="createButton">
                    </AdaButton>
                </div>
            </div>
        </transition>

        <Dialog v-if="showAddInteractionsDialog" :show-close-button="true" :show="showAddInteractionsDialog"
                :has-backdrop="true" width="80%"
                @close="closeDialog">
            <SelectInteractionsFromTable :initial-interactions="interactions"
                                         @selected="interactionsSelected"></SelectInteractionsFromTable>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Dialog from "../../../components/dialog/Dialog";
    import SelectInteractionsFromTable from "./SelectInteractionsFromTable";

    const ModulesRepository = RepositoryFactory.get('modules');

    export default {
        components: {
            BreadCrumb,
            AdaDatatable,
            InputFloatLabel,
            SelectInteractionsFromTable,
            AdaButton,
            Dialog
        },
        data: function () {
            return {
                module: null,
                moduleFetched: false,
                showAddInteractionsDialog: false,
                columns: [
                    {
                        viewName: 'Interaction Name',
                        propName: 'name',
                        sortable: true,
                        width: '25%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '25%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '10%'
                    },
                    {
                        viewName: 'Beschreibung',
                        propName: 'description',
                        width: '40%'
                    }
                ],
                interactions: [],
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'delete':
                                        res += '<span data-type="delete" class="margin-right hover-highlight icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    }
                ],
                savingTemplate: false,
                loading: false,
                fn: null
            }
        },
        name: "EditModuleTemplate",
        async mounted() {
            await this.fetchModule();
            this.fn = () => {
                this.editClicked(true);
            };
            this.$root.$on('saveModuleTemplate', this.fn);
        },
        beforeDestroy() {
            this.$root.$off('saveModuleTemplate', this.fn);
        },
        watch: {
            'module.technical_name': function (newVal, oldVal) {
                this.changeInteractionsTechnicalName(oldVal, newVal);
            }
        },
        methods: {
            arrayMove(array, from, to) {
                array.splice(to, 0, array.splice(from, 1)[0]);
            },
            moveUp(index) {
                if (index > 0) {
                    this.arrayMove(this.interactions, index, index - 1);
                }
            },
            moveDown(index) {
                if (index < this.interactions.length - 1) {
                    this.arrayMove(this.interactions, index, index + 1);
                }
            },
            async fetchModule() {
                this.loading = true;
                try {
                    const {data} = await ModulesRepository.getModule(this.$route.params.id);
                    this.module = data;
                    this.moduleFetched = true;
                    this.deviceType = this.module.medium;
                    this.interactions = this.module.interactions;
                    this.interactions.sort((x, y) => {
                        if (x.pivot.sort < y.pivot.sort) {
                            return -1;
                        }
                        if (x.pivot.sort > y.pivot.sort) {
                            return 1;
                        }
                        return 0;
                    });
                    this.interactions.forEach(inter => {
                        inter.action = ['delete'];
                        inter.selected = true;
                    })
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Modul konnte nicht geladen werden.');
                }
                this.loading = false;
            },
            editClicked(clickedFromHeader) {
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', true) : this.savingTemplate = true;
                this.editModule(clickedFromHeader);
            },
            async editModule(clickedFromHeader) {
                try {
                    const interactionIds = this.interactions.map(inter => inter.id);
                    const json = {
                        id: this.module.id,
                        name: this.module.name,
                        technical_name: this.module.technical_name,
                        interactionIds: interactionIds
                    };
                    await ModulesRepository.updateModule(this.module.id, json);
                    this.$noty.success("Die Modulvorlage wurde erfolgreich aktualisiert!");
                    this.$router.push({name: 'templatemodules'});
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Aktualisierung der Modulvorlage:" + e.message);
                }
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', false) : this.savingTemplate = false;
            },
            interactionsSelected(selectedInteractions) {
                selectedInteractions.forEach(inter => {
                    inter.action = ['delete'];
                    if (inter.technical_name[0] !== '_') {
                        inter.technical_name = '_' + inter.technical_name;
                    }
                    inter.technical_name = this.module.technical_name + inter.technical_name;
                });
                this.interactions = selectedInteractions;
                this.showAddInteractionsDialog = false;
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'delete':
                        this.interactions.splice(this.interactions.indexOf(data.row), 1);
                        break;
                }
            },
            moduleNameChanged(val) {
                this.module.name = val;
            },
            technicalNameChanged(val) {
                this.module.technical_name = val;
            },
            changeInteractionsTechnicalName(oldTechName, newTechName) {
                this.interactions.forEach(inter => {
                    if (oldTechName !== '') {
                        inter.technical_name = inter.technical_name.replace(oldTechName, '');
                    }
                    inter.technical_name = newTechName + inter.technical_name;
                })
            },
            openDialog() {
                this.showAddInteractionsDialog = true;
            },
            closeDialog() {
                this.showAddInteractionsDialog = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .input-row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .medium-row {
        background-color: white;
        padding: 10px;
    }

    .item-row {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: white;
        padding: 10px;
        justify-content: flex-end;
    }

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>